import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchInstalledInfoSearch, fetchInstalledInfoDetails} from '../actions/installedinfosearch'
import {fetchFilterDatas,changeFilterDatas} from '../actions/filter'
import InstalledInfoSearch from '../components/InstalledInfoSearch'

const mapStateToProps = state => {
  const { installedinfosearch,filter } = state
  const {
    isFetching,
    lastUpdated,
    items,
    // totalRows,
    data_details,
  } = installedinfosearch || {
    isFetching: true,
    items: [],
    data_details:[],
    lastUpdated:"",
  }
  const {filterDatas} =filter||{
    filterDatas:[]
  }
  
  return {
    items,
    isFetching,
    lastUpdated,
    // totalRows,
    data_details,
    filterDatas: filterDatas,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInstalledInfoSearch: fetchInstalledInfoSearch,
      getInstalledInfoDetails: fetchInstalledInfoDetails,
      getFilterDatas:fetchFilterDatas,
      changeFilterDatas:changeFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(InstalledInfoSearch)
